import React from 'react';
import { useTranslation } from 'react-i18next';

const ValueProposition = () => {
  const { i18n } = useTranslation();
  const isKo = i18n.language === 'ko';

  const values = [
    {
      num: '01',
      titleKo: '즉각적인 검증',
      titleEn: 'Instant Validation',
      label: 'Instant Check',
      descKo: '이 표현, FDA가 금지하나요? 즉시 검색으로 명확한 답을 찾으세요.',
      descEn: 'Need to know if the FDA may flag this claim? Get a clear answer instantly.'
    },
    {
      num: '02',
      titleKo: '창의적 대안',
      titleEn: 'Creative Alternatives',
      label: 'Creative Alternatives',
      descKo: '그럼 대신 뭐라고 써야 하죠? 규제 안에서 가장 안전하고 창의적인 대안을 제안합니다.',
      descEn: 'We suggest safer, more marketable alternatives within regulatory boundaries.'
    },
    {
      num: '03',
      titleKo: '선제적 알림',
      titleEn: 'Proactive Alerts',
      label: 'Regulatory Signals',
      descKo: 'MoCRA 규정이 또 바뀌었나요? 최신 규제를 자동으로 추적하고 리스크를 알려드립니다.',
      descEn: 'Regulations change fast. VeriPass helps you track updates before risk turns into delay.',
      coming: true
    }
  ];

  return (
    <section className="section-soft" style={{ padding: '72px 0' }}>
      <div className="wrap">
        <div className="grid-3">
          {values.map((v, i) => (
            <div key={i} className={`card card-center${v.coming ? ' coming' : ''}`}>
              {v.coming && <span className="corner-badge">{isKo ? '추후 제공' : 'Coming Soon'}</span>}
              <div className="icon-circle">{v.num}</div>
              <h4>{isKo ? v.titleKo : v.titleEn}</h4>
              <div className="label">{v.label}</div>
              <p>{isKo ? v.descKo : v.descEn}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValueProposition;
